(() => {
  const KEY = "coolstar_saved_designs_v1";
  const form = document.getElementById("set-customizer-form");
  if (!form) return;
  const readDesigns = () => { try { const value = JSON.parse(localStorage.getItem(KEY) || "[]"); return Array.isArray(value) ? value : []; } catch { return []; } };
  const get = name => form.elements.namedItem(name)?.value || "";
  const setText = (selector, text) => { const node = document.querySelector(selector); if (node) node.textContent = text; };
  const countLabel = value => Number(value).toLocaleString("en-US");
  const render = () => {
    const quantity = get("quantity");
    const material = get("material");
    const caseStyle = get("caseStyle");
    const palette = get("palette");
    const labels = { hard: "Hard case", wood: "Wood presentation case", travel: "Compact travel case", gift: "Gift box" };
    const colors = { burgundy: "#8d263b", classic: "#9f6a2f", forest: "#225644", monochrome: "#45434a" };
    setText("#set-preview-count", `${countLabel(quantity)} chips · ${material}`);
    setText("#set-preview-case", labels[caseStyle] || "Hard case");
    setText("#set-preview-name", `${countLabel(quantity)} chips, ready to play.`);
    setText("#set-preview-note", `${material} chips · ${labels[caseStyle] || "Hard case"} · ${get("packaging")} finish`);
    const caseElement = document.querySelector("[data-set-case]");
    if (caseElement) caseElement.style.background = `linear-gradient(145deg,${colors[palette] || colors.burgundy},#211c20)`;
    document.querySelectorAll(".set-stack i").forEach((chip, index) => {
      chip.style.background = index % 4 === 0 ? colors[palette] || colors.burgundy : index % 4 === 1 ? "#1e5a46" : index % 4 === 2 ? "#d8c7a7" : "#303037";
    });
  };
  form.addEventListener("input", render);
  form.addEventListener("change", render);
  const editId = new URLSearchParams(location.search).get("design");
  const existing = readDesigns().find(item => item.id === editId && item.type === "sets");
  if (existing?.config?.fields) {
    Object.entries(existing.config.fields).forEach(([name, saved]) => { const field = form.elements.namedItem(name); if (field && field.type !== "file") field.value = saved; });
    form.elements.namedItem("designName").value = existing.name || "";
  }
  render();
  form.addEventListener("submit", event => {
    event.preventDefault();
    const name = get("designName").trim(); if (!name) return;
    const fields = {};
    [...form.elements].filter(item => item.name && item.type !== "file").forEach(item => { fields[item.name] = item.value; });
    const rows = readDesigns();
    const saved = {
      ...(existing || {}), id: existing?.id || globalThis.crypto?.randomUUID?.() || `design-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      name, type: "sets", material: get("material"), notes: `${countLabel(get("quantity"))} chips · ${get("caseStyle")} · ${get("palette")}`,
      config: { fields }, savedAt: new Date().toISOString()
    };
    try {
      localStorage.setItem(KEY, JSON.stringify([saved, ...rows.filter(item => item.id !== saved.id)]));
      document.getElementById("set-save-status").textContent = "Design saved in this browser. You can find it under My designs.";
    } catch { document.getElementById("set-save-status").textContent = "There is not enough browser storage to save this design. Remove an old design and try again."; }
  });
})();
